/* PrivacyConsentRow: the clientBooking consent row (fields.module.css .checkboxGroup under
   [data-form-appearance='clientBooking']), with the confirmed mockup's error state.
   Client theme tokens only. */
.wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.row {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-height: 44px;
  padding: 11px 13px;
  border-radius: 14px;
  background: var(--bg-inset);
  border: 1px solid var(--text-muted);
  cursor: pointer;
  box-sizing: border-box;
}
.input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.box {
  width: 21px;
  height: 21px;
  flex-shrink: 0;
  margin-top: 2px;
  border: 2px solid var(--text-muted);
  border-radius: 7px;
  background: transparent;
  display: grid;
  place-items: center;
  box-sizing: border-box;
}
.box svg {
  width: 14px;
  height: 14px;
  color: var(--text-on-accent);
  opacity: 0;
}
.input:checked + .box {
  background: var(--accent);
  border-color: var(--accent);
}
.input:checked + .box svg {
  opacity: 1;
}
.input:focus-visible + .box {
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.35);
}
.label {
  align-self: center;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}
.label a {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}
.rowError,
.rowError .box {
  border-color: var(--danger);
}
.error {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--danger);
}
.error svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
